import * as yup from "yup";
import { VALID_DATE, TIME_NOT_IN_FUTURE } from "@common/constants/validation";

export const selfExclusionSchema = yup.object().shape({
  date: VALID_DATE,
  time: TIME_NOT_IN_FUTURE,
  selfExclusionType: yup.object().shape({
    id: yup.number().required("Self-exclusion event is required"),
  }),
  customerReference: yup.string().required("Customer reference is required"),
});
